import React, {
  Dispatch,
  InputHTMLAttributes,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { IconType } from "react-icons";

import DatePicker from "./DatePicker";
import moment from "moment";
import { Container, Error, InpuWrapError, InputMask, Label } from "./styles";

type CustomDatePickerInputProps = InputHTMLAttributes<HTMLInputElement> & {
  id?: string;
  labelText?: string;
  inputType?: string;
  onBlur?: (e: React.FocusEvent<any, Element>) => void;
  onFocus?: (e: React.FocusEvent<any>) => void;
  icon?: IconType;
  msgError?: string;
  errorCondition?: boolean;
  mask?: string;
  disabled?: boolean;
  setDate?: Dispatch<SetStateAction<string>>;
  minDate?: Date;
  maxDate?: Date;
};

const CustomDatePickerInput = ({
  id,
  labelText,
  inputType,
  onBlur,
  onFocus,
  icon: Icon,
  msgError,
  errorCondition,
  mask,
  disabled,
  setDate,
  minDate,
  maxDate,
  ...rest
}: CustomDatePickerInputProps): JSX.Element => {
  const [isFocus, setIsfocus] = useState(false);
  const [inputEmpty, setInputEmpty] = useState(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | string>("");

  useEffect(() => {
    const idRef = document.getElementById(id) as HTMLInputElement;
    if (idRef) {
      idRef.addEventListener("change", (e) => {
        // @ts-expect-error
        const inputValue = e.target.value;
        if (inputValue) {
          const splitDate = inputValue.split("/");
          setSelectedDate(
            new Date(splitDate[2], splitDate[1] - 1, splitDate[0])
          );
          idRef.value = inputValue;
          if (setDate) {
            setDate(inputValue);
          }
        }
      });
    }
  }, [rest]);

  useEffect(() => {
    const idRef = document.getElementById(id) as HTMLInputElement;
    if (idRef) {
      const inputValue = idRef ? idRef?.value || "" : "";
      setInputEmpty(inputValue.length === 0);
    }
  }, [rest, selectedDate]);

  function handleSetInputValue(): void {
    setShowDatePicker(false);
    const idRef = document.getElementById(id) as HTMLInputElement;
    idRef.dispatchEvent(new Event("change"));
    idRef.value = moment(selectedDate).format("DD/MM/YYYY");
    if (setDate) {
      setDate(moment(selectedDate).format("DD/MM/YYYY"));
    }
  }

  return (
    <>
      <InpuWrapError>
        <Container
          withIcon={!!Icon}
          whitError={errorCondition}
          disabled={disabled}
        >
          {Icon && (
            <Icon
              size={26}
              onClick={() => {
                if (!disabled) {
                  setShowDatePicker(true);
                }
              }}
              style={{ cursor: "pointer" }}
            />
          )}
          <Label isFocus={isFocus || !inputEmpty}>{labelText}</Label>
          <InputMask
            id={id}
            disabled={disabled}
            mask={mask}
            type={inputType}
            onFocus={(e) => {
              setIsfocus(true);
              if (onFocus && typeof onFocus === "function") onFocus(e);
            }}
            onBlur={(e) => {
              setIsfocus(false);
              if (onBlur && typeof onBlur === "function") onBlur(e);
            }}
            {...rest}
          />
        </Container>
        {errorCondition && msgError && <Error>{msgError}</Error>}
      </InpuWrapError>
      {showDatePicker && (
        <DatePicker
          buttonCancel={() => setShowDatePicker(false)}
          buttonOk={() => handleSetInputValue()}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate || maxDate}
          minDate={minDate}
          maxDate={maxDate}
        />
      )}
    </>
  );
};

export default CustomDatePickerInput;
